<template lang="html">
  <div id="home-page">

    <!-- Banners  -->
    <section class="container-fluid banner-section">
      <swiper class="swiper-desktop" :options="bannersOption">
        <swiper-slide v-for="(banner, index) in banners.pc" :key="index">
          <a class="placed-backg" :href="banner.url ?  banner.url : '#'" v-bind:style="{ backgroundImage: 'url('+banner.image+')' }">
            <img src="public/images/pages/home/banner.png">
          </a>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>

      <swiper class="swiper-mobile" :options="bannersOption">
        <swiper-slide  v-for="(banner, index) in banners.movil" :key="index">
           <a class="placed-backg" :href="banner.url ?  banner.url : '#'" v-bind:style="{ backgroundImage: 'url('+banner.image+')' }">
             <img src="public/images/pages/home/banner-m.png">
           </a>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </section>
    <!--  -->

    <!-- Categorias -->
    <section class="categories-section">
      <div class="container oversized-container">
        <div class="col-12 col-sm-title">
          <!-- <h2 class="title">Categorías</h2> -->

          <!-- <p>
            Nuestra misión es, abastecer con nuestra gama de productos a nuestros clientes y futuros distribuidores.
          </p> -->
        </div>

        <div class="box-services">
          <swiper class="swiper" :options="categoriesOptions">
            <swiper-slide v-for="(s, shInx) in categories" :key="'shInx-'+shInx">
              <div class="col-12 px-0 box-service-sample-1">
                <router-link class="placed-backg box" v-bind:style="{ backgroundImage: 'url('+s.image+')' }" :to="'/subcategoria/'+$root._converToURL(s.name, s.id)">
                  <img class="fake-img" src="public/images/shared/empty.png">

                  <div class="placed-backg box-text">
                    <h5>{{ s.name }}</h5>
                  </div>
                </router-link>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Productos -->
    <section class="container oversized-container mb-4 products-section" v-if="products_c1.length">
      <div class="row">
        <div class="col-12 col-sm-title">
          <h2 class="title">Nuestros productos</h2>

          <!-- <p>
            Nuestra misión es, abastecer con nuestra gama de productos a nuestros clientes y futuros distribuidores.
          </p> -->
        </div>
      </div>

      <div class="row">
        <div class="col-12 px-0 col-products">
          <swiper class="swiper carousel-t1 ct1-white" :options="productsOption">
            <swiper-slide v-for="(product, index) in products_c1" :key="index">
              <div class="col-12 px-0 sample-product shad-prod">
                <a class="outlined-box">
                  <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>
                  <div class="box-image">
                    <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                    <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.image+')' }">
                      <img src="public/images/shared/empty.png" >
                    </div>
                  </div>

                  <div class="box-shot-descr">
                    <h6 class="brand">{{ product.sku }}</h6>
                    <h6 class="name">{{ product.name }}</h6>
                    <!-- <h6 class="brand">{{ product.brand }}</h6> -->
                    <h6 class="price discount" v-if="product.offer_price"><span>{{ product.offer_price }}</span></h6>
                    <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</h6>
                  </div>

                  <cart-component :product="product"></cart-component>
                </a>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Productos -->
    <section class="mb-4 products-section bg-1 line-b-green">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-12 col-sm-title">
            <h2 class="title">Productos destacados</h2>

            <!-- <p>
              Nuestra misión es, abastecer con nuestra gama de productos a nuestros clientes y futuros distribuidores.
            </p> -->
          </div>
        </div>

        <div class="row">
          <div class="col-12 px-0 col-products">
            <swiper class="swiper carousel-t1 ct1-white" :options="productsOption">
              <swiper-slide v-for="(product, index) in products_c2" :key="index">
                <div class="col-12 px-0 sample-product shad-prod">
                  <a class="outlined-box">
                    <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>
                    <div class="box-image">
                      <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                      <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.image+')' }">
                        <img src="public/images/shared/empty.png" >
                      </div>
                    </div>

                    <div class="box-shot-descr">
                      <h6 class="brand">{{ product.sku }}</h6>
                      <h6 class="name">{{ product.name }}</h6>
                      <!-- <h6 class="brand">{{ product.brand }}</h6> -->
                      <h6 class="price discount" v-if="product.offer_price"><span>{{ product.offer_price }}</span></h6>
                      <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</h6>
                    </div>

                    <cart-component :product="product"></cart-component>
                  </a>
                </div>
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Company -->
    <CompanyComponent></CompanyComponent>
    <!--  -->

    <!-- Multibanners -->
    <!-- <section class="container oversized-container multi-banners-section">
      <swiper class="swiper" :options="multibanersOptions">
        <swiper-slide v-for="(banner, bxhInx) in banner_middle" :key="'bxhInx-'+bxhInx">
          <div class="col-12 px-0 col-banner">
            <a :href="banner.url">
              <img :src="banner.imageUrl">
            </a>
          </div>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </section>  -->

    <!-- Simple banner -->
    <!-- <section class="simple-banner-section">
      <router-link class="img-desktop" to="">
        <img src="public/images/pages/home/banner-e-1.jpg">
      </router-link>

      <router-link class="img-mobile" to="">
        <img src="public/images/pages/home/banner-e-1-m.jpg">
      </router-link>
    </section> -->
    <!-- Simple banner -->

    <!-- Productos | Populares -->
    <section class="products-section bg-2 line-gray">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-12 col-sm-title">
            <h2 class="title">Recien agregados</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-12 px-0 col-products">
            <swiper class="swiper carousel-t1 ct1-white" :options="productsOption">
              <swiper-slide v-for="(product, index) in products_c3" :key="index">
                <div class="col-12 px-0 sample-product shad-prod">
                  <a class="outlined-box">
                    <router-link class="fake-link" :to="'/producto/'+$root._converToURL(product.name, product.id)"></router-link>

                    <div class="box-image">
                      <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>

                      <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.imageUrl+')' }">
                        <img src="public/images/shared/empty.png" >
                      </div>
                    </div>

                    <div class="box-shot-descr">
                      <h6 class="brand">{{ product.sku }}</h6>
                      <h6 class="name">{{ product.name }}</h6>
                      <h6 class="brand">{{ product.brand }}</h6>
                      <!-- <h6 class="price discount"><span>$ {{ product.price }}</span></h6> -->
                      <h6 class="price">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }}</h6>
                    </div>

                    <cart-component :product="product"></cart-component>
                  </a>
                </div>
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->

    <!-- Customers -->
    <!-- <div class="customers-section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-title">
            <h2 class="title">Nuestros clientes</h2>
          </div>

          <div class="col-lg-4 col-logo">
            <img src="public/images/pages/about-us/mercedes-benz.png">
          </div>

          <div class="col-lg-4 col-logo">
            <img src="public/images/pages/about-us/volvo.png">
          </div>

          <div class="col-lg-4 col-logo">
            <img src="public/images/pages/about-us/volkswagen.png">
          </div>
        </div>
      </div>
    </div> -->
    <!--  -->

    <!-- Blog -->
    <!-- <section class="container oversized-container pb-4 brands-section" v-if="blogs.length">
      <div class="row">
        <div class="col-12 col-s-title">
          <h2 class="title">Posts destacados</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6 col-lg-4 col-xl-3 col-article-sample-1" v-for="(blog, baInx) in blogs" :key="'ba-'+baInx">
          <router-link class="box-article" :to="'/blog/'+$root._converToURL(blog.title, blog.id)">
            <div class="placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+blog.imageUrl+')' }">
              <img src="public/images/pages/blog/empty.png">
            </div>

            <div class="box-descr">
              <h5>{{ blog.title }}</h5>
              <div class="descr" v-html="blog.body"></div>
            </div>
          </router-link>
        </div>
      </div>
    </section> -->
    <!--  -->

    <!-- Modal de imagen con publicidad -->
    <!-- <b-modal ref="modal-promo" size="lg" modal-class="modal-home-promo" centered hide-footer title="">
      <img :src="modal">
    </b-modal> -->
    <!--  -->

  </div>
</template>

<script>
import CompanyComponent from './company/company-component.vue';
export default {
  components: {
    CompanyComponent
  },

  data(){
    return{
      banners:{
        pc:[
          // { id: 1, url: null, image: 'public/images/pages/home/banner-1.jpg' },
        ],
        movil:[
          // { id: 1, url: null, image: 'public/images/pages/home/banner-1-m.jpg' },
        ]
      },

      categories: [
        // { imageUrl: 'public/images/pages/products/category-1.jpg', name: 'Automotriz' },
        // { imageUrl: 'public/images/pages/products/category-2.jpg', name: 'Industrial' },
        // { imageUrl: 'public/images/pages/products/category-3.jpg', name: 'Equipo pesado' },
        // { imageUrl: 'public/images/pages/products/category-4.jpg', name: 'Grapa automotriz' },
        // { imageUrl: 'public/images/pages/products/category-2.jpg', name: 'Industrial' },
      ],

      banner_middle:[],
      products_c1:[
        // {
        //   "id": 5,
        //   "sku": "LU23535017",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAX. 3 LINEAS",
        //   "price": "1250.00",
        //   "stock": 9,
        //   "imageUrl": "public/images/pages/products/product-5.jpg"
        // },
        // {
        //   "id": 4,
        //   "sku": "LUCH101",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAX. 3 LINEAS",
        //   "price": "850.00",
        //   "stock": 2,
        //   "imageUrl": "public/images/pages/products/product-4.jpg"
        // },
        // {
        //   "id": 2,
        //   "sku": "LUCC114",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAX. 3 LINEAS",
        //   "price": "450.00",
        //   "stock": 3,
        //   "imageUrl": "public/images/pages/products/product-2.jpg"
        // },
        // {
        //   "id": 3,
        //   "sku": "LUCG100",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAX. 3 LINEAS",
        //   "price": "289.00",
        //   "stock": 5,
        //   "imageUrl": "public/images/pages/products/product-3.jpg"
        // },
        // {
        //   "id": 1,
        //   "sku": "LUCC111",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAX. 3 LINEAS",
        //   "price": "3050.00",
        //   "stock": 1,
        //   "imageUrl": "public/images/pages/products/product-1.jpg"
        // },
      ],
      products_c2:[
        // {
        //   "id": 1,
        //   "sku": "LUCC111",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAX. 3 LINEAS",
        //   "price": "3050.00",
        //   "stock": 1,
        //   "imageUrl": "public/images/pages/products/product-1.jpg"
        // },
        // {
        //   "id": 4,
        //   "sku": "LUCH101",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAX. 3 LINEAS",
        //   "price": "850.00",
        //   "stock": 2,
        //   "imageUrl": "public/images/pages/products/product-6.jpg"
        // },
        // {
        //   "id": 2,
        //   "sku": "LUCC114",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAX. 3 LINEAS",
        //   "price": "450.00",
        //   "stock": 3,
        //   "imageUrl": "public/images/pages/products/product-8.jpg"
        // },
        // {
        //   "id": 3,
        //   "sku": "LUCG100",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAX. 3 LINEAS",
        //   "price": "289.00",
        //   "stock": 5,
        //   "imageUrl": "public/images/pages/products/product-9.jpg"
        // },
        // {
        //   "id": 5,
        //   "sku": "LU23535017",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAX. 3 LINEAS",
        //   "price": "1250.00",
        //   "stock": 9,
        //   "imageUrl": "public/images/pages/products/product-5.jpg"
        // },
      ],
      products_c3: [
        // {
        //   "id": 1,
        //   "sku": "LUCC111",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAXIMO DE 3 LINEAS",
        //   "price": "3050.00",
        //   "stock": 1,
        //   "imageUrl": "public/images/pages/products/product-1.jpg"
        // },
        // {
        //   "id": 2,
        //   "sku": "LUCC114",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAXIMO DE 3 LINEAS",
        //   "price": "450.00",
        //   "stock": 3,
        //   "imageUrl": "public/images/pages/products/product-2.jpg",
        // },
        // {
        //   "id": 3,
        //   "sku": "LUCG100",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAXIMO DE 3 LINEAS",
        //   "price": "289.00",
        //   "stock": 5,
        //   "imageUrl": "public/images/pages/products/product-3.jpg"
        // },
        // {
        //   "id": 4,
        //   "sku": "LUCH101",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAXIMO DE 3 LINEAS",
        //   "price": "850.00",
        //   "stock": 2,
        //   "imageUrl": "public/images/pages/products/product-4.jpg"
        // },
        // {
        //   "id": 5,
        //   "sku": "LU23535017",
        //   "name": "EJEMPLO DE NOMBRE DE PRODUCTO AQUÍ, CON MAXIMO DE 3 LINEAS",
        //   "price": "1250.00",
        //   "stock": 9,
        //   "imageUrl": "public/images/pages/products/product-5.jpg"
        // },
      ],

      /* == Carousel options == */
      bannersOption: {
        loop: true,
        speed:800,
        effect: 'fade',

        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true
        },

        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
      },

      productsOption: {
        loop: false,
        slidesPerView: 5,
        spaceBetween: 10,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1399: {
            slidesPerView: 5
          },
          1199: {
            slidesPerView: 4
          },
          991: {
            spaceBetween: 10,
            slidesPerView: 3
          },
          575: {
            spaceBetween: 20,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        },
        autoplay: {
          delay: 5000, // Cambia el tiempo de retardo según lo que necesites
          disableOnInteraction: false
        },
        effect: 'slide', // Puedes cambiarlo a 'fade', 'cube', 'coverflow', etc.
        speed: 600 // La velocidad de la transición en milisegundos
      },

      categoriesOptions: {
        slidesPerView: 4,
        spaceBetween: 30,

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true,
        },

        breakpoints: {
          1600: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1,
          },
        }
      },

      multibanersOptions: {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 30,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1400: {
            slidesPerView: 4
          },
          992: {
            slidesPerView: 3
          },
          768: {
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        },
      }
      // == ==
    }
  },

  methods: {
    getHome: function(){
      axios.get(tools.url('/api/home')).then(({data}) =>{
        this.banners = data.banners;
        this.products_c1 = data.products;
        this.products_c2 = data.featured_products;
        this.products_c3 = data.last_products;

        this.categories = data.subcategories;
      });
    },
  },

  mounted(){
    this.getHome();
  }
}
</script>
